module.exports = __webpack_public_path__ + "static/licencewhite-c3af99269aa2bfb4c6c2f11937a6da50.svg";